const flattenOptions = (options) => (
  options.reduce((a, option) => [...a, option, ...flattenOptions(option.options)], [])
);

const getAncestors = ({ parent_id: parentId }, options) => (
  options.flatMap((option) => (
    option.value === parentId ? [option, ...getAncestors(option, options)] : []
  ), [])
);

const getSelectedOptions = (selection, options) => {
  if (!selection.length) return [];

  return flattenOptions(options).filter(({ value }) => selection.includes(value));
};

const getSelectionAncestors = (selectedOptions, options) => {
  if (!selectedOptions.length) return [];

  const flattened = flattenOptions(options);

  const ancestors = selectedOptions.reduce((a, option) => [
    ...a,
    ...getAncestors(option, flattened),
  ], []);

  return [...new Set(ancestors.map(({ value }) => value))];
};

export { getSelectedOptions, getSelectionAncestors };
